// extracted by mini-css-extract-plugin
export var blog = "blog-module--blog--TbHSA";
export var titleSectionWrapper = "blog-module--title-section-wrapper---Ra4F";